/*! @pentacode/ui v0.1.0 */
import { a as e, c as t, d as n, i as r, l as i, r as a, s as o, u as s } from "./shared-D0HMDGlg.js";
import { n as c, r as l } from "./rule-D2ufK5oT.js";
import { r as u } from "./scene-Bdst6a-n.js";
import { t as d } from "./bar-COFxhm37.js";
import { t as f } from "./stack-B6GnFAsl.js";
import { r as p } from "./theme-BfnA-mmC.js";
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/group.js
function m(e = {}) {
	return {
		type: "group",
		...e
	};
}
//#endregion
//#region src/charts/presets/bar.ts
function h(h, { stacked: g = !1, line: _ = [], ...v } = {}) {
	let { format: y = o, xFormat: b, valueLabel: x, colors: S, legend: C, yAxis: w, highlight: T } = v, E = i([...h, ..._]), D = t, O = g ? f({ order: i(h) }) : m({ padding: .15 });
	return u({
		theme: p,
		marks: [
			d(h, {
				...D,
				layout: O,
				inset: 2,
				radius: g ? void 0 : { end: 4 }
			}),
			..._.length ? [l(_, {
				...D,
				strokeWidth: 2,
				points: !0,
				curve: s
			})] : [],
			c([0])
		],
		scales: {
			x: a(h, "band", b),
			y: n(y, x, w)
		},
		color: r(E, S, C, T),
		focus: "group-x",
		focusRing: !1,
		tooltip: e(h, y, b)
	});
}
//#endregion
export { m as n, h as t };

//# sourceMappingURL=bar-BOoQWHCa.js.map